/* ==========================================================================
   00FIERCE — BILDER WISCHEN auf der Glas-Kachel · Okt 2026
   Gehoert zu snippets/khs-card-swipe.liquid und assets/khs-card-glass.css.
   Wird nur geladen, wenn 00F Kacheln > Stil = Glas-Kapsel und
   "Bilder auf der Kachel wischen" an ist.

   Das Wischen selbst ist natives Scroll-Snap (geht auch ohne dieses Skript).
   Hier passiert nur:
   · Anzeige (Story-Balken / Punkte / Linie) und Pfeile mitfuehren
   · Desktop: Pfeile oder "Maus faehrt durch die Bilder"
   · Pfeiltasten, wenn die Bildleiste den Fokus hat
   · Bilder ab 2 laden, sobald jemand die Kachel beruehrt oder drueberfaehrt
   · einmal pro Besuch kurzes Anstupsen der ersten Kachel als Hinweis
   Alles laeuft ueber document (Delegation), funktioniert also auch nach dem
   Neuladen des Rasters durch Filter (facets.js).
   ========================================================================== */
(function () {
  'use strict';

  if (window.__khsCardSwipe) return;
  window.__khsCardSwipe = true;

  var mq = function (q) { return window.matchMedia ? window.matchMedia(q).matches : false; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var finePointer = mq('(hover: hover) and (pointer: fine)');

  function countOf(sw) { return parseInt(sw.getAttribute('data-count'), 10) || 1; }
  function trackOf(sw) { return sw.querySelector('.khs-sw__track'); }
  function stepOf(track) {
    var slide = track.querySelector('.khs-sw__slide');
    return slide ? slide.offsetWidth : track.clientWidth;
  }
  function indexOf(sw) {
    var track = trackOf(sw), n = countOf(sw);
    var max = track.scrollWidth - track.clientWidth;
    if (max > 0 && track.scrollLeft >= max - 2) return n - 1;
    var i = Math.round(track.scrollLeft / (stepOf(track) || 1));
    return Math.max(0, Math.min(n - 1, i));
  }
  function paint(sw) {
    var i = indexOf(sw), n = countOf(sw);
    var marks = sw.querySelectorAll('.khs-sw__bars i, .khs-sw__dots i');
    for (var k = 0; k < marks.length; k++) marks[k].classList.toggle('is-on', k === i);
    sw.style.setProperty('--khs-sw-i', i);
    var prev = sw.querySelector('.khs-sw__nav--prev');
    var next = sw.querySelector('.khs-sw__nav--next');
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === n - 1;
  }
  function go(sw, i, instant) {
    var track = trackOf(sw), n = countOf(sw);
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: i * stepOf(track), behavior: (instant || reduce) ? 'auto' : 'smooth' });
  }
  function warm(sw) {
    if (!sw || sw.__khsWarm) return;
    sw.__khsWarm = true;
    var imgs = sw.querySelectorAll('img[loading="lazy"]');
    for (var k = 0; k < imgs.length; k++) imgs[k].loading = 'eager';
  }
  function swFrom(target) {
    return target && target.closest ? target.closest('.khs-sw') : null;
  }

  /* scroll bubbelt nicht, laesst sich aber in der Capture-Phase abfangen */
  var queued = [], raf = 0;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('khs-sw__track')) return;
    var sw = t.parentElement;
    warm(sw);
    if (queued.indexOf(sw) === -1) queued.push(sw);
    if (!raf) {
      raf = requestAnimationFrame(function () {
        raf = 0;
        var list = queued; queued = [];
        list.forEach(paint);
      });
    }
  }, true);

  /* Pfeile */
  document.addEventListener('click', function (e) {
    var nav = e.target.closest ? e.target.closest('.khs-sw__nav') : null;
    if (!nav) return;
    e.preventDefault();
    e.stopPropagation();
    var sw = swFrom(nav);
    warm(sw);
    go(sw, indexOf(sw) + (nav.classList.contains('khs-sw__nav--next') ? 1 : -1));
  });
  /* Druck-Effekt fuer wischbare Kacheln.
     khs-kinetic.js setzt .khs-pressed (= scale) sofort beim Antippen — in
     dem Moment verliert Safari aber die Wischgeste. Deshalb uebernehmen wir
     das hier fuer Beruehrungen auf dem Bild, mit eigener Klasse
     .khs-sw-pressed (die Kinetik raeumt ihre eigene beim Loslassen weg):
     Die Kachel drueckt sich erst
     nach kurzem Halten ein, oder kurz beim Loslassen eines Tipps. Sobald
     sich der Finger bewegt oder etwas scrollt, gibt es keinen Effekt. */
  var PRESS_DELAY = 110;   /* ms Halten ohne Bewegung */
  var TAP_FLASH = 170;     /* ms Effekt nach einem kurzen Tipp */
  var MOVE_TOL = 8;        /* px Bewegung, ab der es ein Wischen ist */
  var press = null;

  function pressRoot(sw) {
    return sw ? sw.closest('.card-wrapper, .khs-sp__card') : null;
  }
  function cancelPress() {
    if (!press) return;
    clearTimeout(press.timer);
    press.root.classList.remove('khs-sw-pressed');
    press = null;
  }

  document.addEventListener('pointerdown', function (e) {
    var sw = swFrom(e.target);
    if (!sw) return;
    /* Sticker-Karussell (v3.4+): Seitenkarten sind nicht wischbar, dort
       gehoert die Geste dem Karussell */
    if (sw.closest('.khs-sc__item:not(.is-active)')) return;
    /* khs-kinetic.js soll hier nicht sofort eindruecken */
    e.stopPropagation();
    cancelPress();
    if (e.target.closest('.khs-sw__nav') || (e.button && e.button !== 0)) return;
    var root = pressRoot(sw);
    if (!root) return;
    press = { root: root, x: e.clientX, y: e.clientY, on: false };
    press.timer = setTimeout(function () {
      if (!press || press.root !== root) return;
      press.on = true;
      root.classList.add('khs-sw-pressed');
    }, PRESS_DELAY);
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!press) return;
    if (Math.abs(e.clientX - press.x) > MOVE_TOL || Math.abs(e.clientY - press.y) > MOVE_TOL) cancelPress();
  }, { capture: true, passive: true });

  document.addEventListener('pointerup', function () {
    if (!press) return;
    var p = press;
    press = null;
    clearTimeout(p.timer);
    p.root.classList.add('khs-sw-pressed');
    setTimeout(function () { p.root.classList.remove('khs-sw-pressed'); }, p.on ? 60 : TAP_FLASH);
  }, true);

  document.addEventListener('pointercancel', cancelPress, true);
  /* jedes Scrollen (Seite oder Bildleiste) bricht den Druck-Effekt ab */
  document.addEventListener('scroll', cancelPress, { capture: true, passive: true });

  /* Tastatur: Pfeiltasten auf der fokussierten Bildleiste */
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('khs-sw__track')) return;
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    var sw = t.parentElement;
    warm(sw);
    go(sw, indexOf(sw) + (e.key === 'ArrowRight' ? 1 : -1));
  });

  /* Bilder vorladen, sobald jemand die Kachel beruehrt oder drueberfaehrt */
  document.addEventListener('pointerover', function (e) { warm(swFrom(e.target)); }, { passive: true });
  document.addEventListener('touchstart', function (e) { warm(swFrom(e.target)); }, { passive: true });

  /* Desktop "Maus faehrt durch": Position der Maus waehlt das Bild */
  if (finePointer) {
    document.addEventListener('mousemove', function (e) {
      var sw = e.target.closest ? e.target.closest('.khs-sw--scrub') : null;
      if (!sw) return;
      var track = trackOf(sw), n = countOf(sw);
      var r = track.getBoundingClientRect();
      if (!r.width) return;
      var i = Math.max(0, Math.min(n - 1, Math.floor((e.clientX - r.left) / r.width * n)));
      if (i !== sw.__khsScrub) {
        sw.__khsScrub = i;
        warm(sw);
        go(sw, i, true);
      }
    });
    document.addEventListener('mouseout', function (e) {
      var sw = e.target.closest ? e.target.closest('.khs-sw--scrub') : null;
      if (!sw || (e.relatedTarget && sw.contains(e.relatedTarget))) return;
      sw.__khsScrub = 0;
      go(sw, 0, true);
    });
  }

  /* Punkte und Linie sitzen 8px ueber der Glas-Kapsel. Bei zweizeiligen
     Namen wird die Kapsel hoeher, deshalb messen wir den echten Abstand von
     der Unterkante der Bildleiste bis zur Oberkante der Kapsel und geben ihn
     als --khs-gl-capoff an die Bildleiste (v3.6). Gemessen wird ueber
     offsetTop, also ohne Karussell-Verschiebung oder -Verkleinerung.
     Ohne dieses Skript gilt die normale Kapselhoehe aus dem CSS. */
  function layoutTop(el) {
    var y = 0;
    while (el) { y += el.offsetTop; el = el.offsetParent; }
    return y;
  }
  function placeDots(sw) {
    var cap = sw.__khsCap;
    if (!cap || !sw.isConnected || !cap.offsetHeight) return;
    var off = Math.round(layoutTop(sw) + sw.offsetHeight - layoutTop(cap));
    if (off > 0 && off !== sw.__khsCapOff) {
      sw.__khsCapOff = off;
      sw.style.setProperty('--khs-gl-capoff', off + 'px');
    }
  }
  var capRO = ('ResizeObserver' in window) ? new ResizeObserver(function (entries) {
    for (var k = 0; k < entries.length; k++) {
      var el = entries[k].target, sw = el.__khsSw || el;
      if (!el.isConnected) { capRO.unobserve(el); continue; }
      placeDots(sw);
    }
  }) : null;
  function fitDots() {
    if (!capRO) return;
    var list = document.querySelectorAll('.khs-sw');
    for (var k = 0; k < list.length; k++) {
      var sw = list[k];
      if (sw.__khsCap) continue;
      var root = sw.closest('.card-wrapper, .khs-sp__card');
      var cap = root ? root.querySelector('.card-information, .khs-gl-cap') : null;
      if (!cap) continue;
      sw.__khsCap = cap;
      cap.__khsSw = sw;
      capRO.observe(cap);
      capRO.observe(sw);
    }
  }
  /* neue Kacheln (Filter, Karussell, Editor) automatisch mitnehmen */
  if (capRO && 'MutationObserver' in window) {
    var fitQueued = false;
    new MutationObserver(function (muts) {
      if (fitQueued) return;
      for (var m = 0; m < muts.length; m++) {
        var add = muts[m].addedNodes;
        for (var a = 0; a < add.length; a++) {
          if (add[a].nodeType !== 1) continue;
          fitQueued = true;
          requestAnimationFrame(function () { fitQueued = false; fitDots(); });
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Hinweis: erste wischbare Kachel rutscht einmal kurz an */
  function nudge() {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var first = document.querySelector('.khs-sw[data-khs-nudge]');
    if (!first) return;
    try { if (sessionStorage.getItem('khs_sw_nudged')) return; } catch (err) {}
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.disconnect();
        try { sessionStorage.setItem('khs_sw_nudged', '1'); } catch (err) {}
        var sw = en.target;
        setTimeout(function () {
          if (indexOf(sw) !== 0) return; /* schon selbst gewischt */
          sw.classList.add('khs-sw--nudge');
          var done = function () {
            sw.classList.remove('khs-sw--nudge');
            sw.removeEventListener('animationend', done);
          };
          sw.addEventListener('animationend', done);
          setTimeout(done, 1600);
        }, 450);
      });
    }, { threshold: 0.6 });
    io.observe(first);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fitDots(); nudge(); });
  } else {
    fitDots();
    nudge();
  }
})();
